// extracted by mini-css-extract-plugin
export default {"row":"infoRow__row-CWQeR"};